import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { catchError, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CheckoutService {

  constructor(private api: ApiService) { }

  getLocations(): Observable<any[]> {
    return this.api.get<any[]>('locations');
  }

  createPreference(cartItems: any[], user: any, userRegister: boolean) {
    let card = {};
    console.log("user", user);
    if(userRegister) {
       card = {
        "userId": user.id,
       }
    }else{
      card = {
        "guestName": (user.nombre || '') + " " + (user.apellido || ''),
        "guestEmail": user.email,
        "guestAddress": (user.departamento || '') + " " + (user.ciudad || '') + " " + (user.direccion || ''),
        "guestPhone": user.telefono,
      }
    }

    const items = cartItems.map(item => ({
      productId: item.product?.id || item.productId,
      quantity: item.quantity,
      color: item.color,
      size: item.size,
      price: item.product?.price || item.price
    }));

    console.log("items", items);
    console.log("card", card);

    return this.api.post<any>('createCart', {
      items,
      card
    });
  }

  async getPaymentStatus(paymentId: string, cartId: string, userId?:string): Promise<any> {  
    console.log("URL construida:", `payment/status/${paymentId}?cartId=${cartId}&userId=${userId}`);
    
    return this.api.get<any>(`payment/status/${paymentId}?cartId=${cartId}&userId=${userId}`)
      .pipe(
        tap(response => console.log("Respuesta de la API:", response)),
        catchError(error => {
          console.error("Error en la llamada:", error);
          throw error;
        })
      ).toPromise();
  }

  async deleteCart(cartId: string): Promise<any> {  
    console.log("URL construida:", `carts${cartId}`);
    return this.api.delete<any>(`carts/${cartId}`).pipe(
      tap(response => console.log("Respuesta de la API:", response)),
      catchError(error => {
        console.error("Error en la llamada:", error);
        throw error;
      })
    ).toPromise();
  }

  getShippingQuotes(input: { destinationCity: string; weightKg?: number; subtotalAmount: number; isCOD?: boolean }) {
    return this.api.post<any>('shipping/quote', input);
  }

  getUserAddresses(userId: string): Observable<any[]> {
    return this.api.get<any[]>(`users/${userId}/addresses`);
  }

  getUserProfile(userId: string): Observable<any> {
    return this.api.get<any>(`users/${userId}`);
  }

  saveUserAddress(userId: string, addressData: { address: string; complement?: string; cityId?: string; departmentId?: string }): Observable<any> {
    return this.api.post<any>(`users/${userId}/addresses`, addressData);
  }

  updateUserProfile(userId: string, userData: any): Observable<any> {
    return this.api.patch<any>(`users/${userId}`, userData);
  }
}
